module.exports = __webpack_public_path__ + "img/defalutRound.8fe39a2f.png";